import moment from "moment-timezone";
import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import styled from "styled-components";
import { ChatDetailType } from "../../controller/DirectMessageController";
import "../../styles/CustomModal.css";
import { chatState, chatType } from "../../recoil/chat";
import { getRecoil, resetRecoil } from "recoil-nexus";
import { authState, currentStoreState } from "../../recoil/auth";
import ConfirmModal from "./ConfirmModal";
import DirectMessageController from "../../controller/DirectMessageController";
import LogController from "../../controller/LogController";

type Props = {
  isVisible: chatType;
  chatDetail: ChatDetailType[];
  setChatDetail: any;
  status: number;
};

const ChatDetailModal = ({
  isVisible,
  chatDetail,
  setChatDetail,
  status,
}: Props) => {
  const [reply, setReply] = useState<string>("");
  const [isComposing, setIsComposing] = useState<boolean>(false);

  const [visibleConfirm, setVisibleConfirm] = useState<boolean>(false);

  const chatEndRef = useRef<HTMLDivElement | null>(null);

  const onCloseModal = () => {
    setVisibleConfirm(false);
    resetRecoil(chatState);
  };

  const scrollToBottom = () => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleCompositionStart = () => {
    setIsComposing(true);
  };

  const handleCompositionEnd = () => {
    setIsComposing(false);
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (isComposing) return;

    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      sendRequest();
    }
  };

  const finishChat = async () => {
    try {
      const oParams = {
        cs_id: isVisible.chat_id,
        sender_type: "STORE",
        user_token_id: getRecoil(authState).user_token_id,
      };
      const oResponse = await DirectMessageController.finishChat(oParams);
      if (oResponse && oResponse.data) {
        const oRes = oResponse.data;
        if (oRes && oRes.ok) {
          onCloseModal();
          toast.success("상담이 종료되었습니다");
          LogController.click({
            path: "chatDetailModal",
            params: "채팅 종료",
            params2: "",
          });
        }
      }
    } catch (e) {
      console.error("err => ", e);
    }
  };

  const sendRequest = async () => {
    if (reply === "") {
      toast.error("답변을 입력해주세요.");
    } else {
      const newMessage = {
        sender_type: "STORE",
        read: 1,
        created_at: new Date(),
        read_at: null,
        chat: reply,
      };

      try {
        const oParams = {
          cs_id: isVisible.cs_id,
          message: reply,
          sender_type: "STORE",
          lang: 0,
          user_token_id: getRecoil(authState).user_token_id,
        };

        setChatDetail((prevChatDetail: any) => [...prevChatDetail, newMessage]);
        setReply("");

        const oRes: any = await DirectMessageController.writeMessage(oParams);

        if (oRes && oRes.data.ok) {
        } else {
          setChatDetail((prevChatDetail: any) =>
            prevChatDetail.map((msg: any) =>
              msg === newMessage ? { ...msg, failed: true } : msg
            )
          );
        }
      } catch (err) {
        console.log("err-->", err);

        setChatDetail((prevChatDetail: any) =>
          prevChatDetail.map((msg: any) =>
            msg === newMessage ? { ...msg, failed: true } : msg
          )
        );
      }
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [chatDetail]);

  return (
    <Modal
      open={isVisible.visible}
      onClose={onCloseModal}
      center
      classNames={{
        overlay: "chatDetailModalOverlay",
        modal: "chatDetailModal",
        root: "customModalRoot",
      }}
      showCloseIcon={true}
      animationDuration={150}
    >
      <Style>
        <div className={`modalWrapper`}>
          <div className="modalTitle">
            <img
              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_siren.svg`}
              alt="siren"
            />
            <h2>주문고객 긴급연락</h2>
            <div className="warningWrap">
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_warning_round.svg`}
                alt="warning"
              />
              <h4>
                호텔에 휴식중인 고객입니다. 불필요한 연락은 절대 금지합니다.
                <span>예외) 상품누락, 주문오류</span>
              </h4>
            </div>
          </div>

          <div className="modalContent">
            <div className="chatWrap">
              <div className="title">
                <h3>{isVisible.area_name}</h3>
              </div>
              <div className="content">
                {chatDetail.map((item, index) => (
                  <div
                    key={index}
                    className={`chat ${item.sender_type === "STORE" && "mine"}`}
                  >
                    {item.sender_type === "STORE" && !item.failed && (
                      <p>
                        {`${
                          new Date(item.created_at).getHours() > 12
                            ? "오후"
                            : "오전"
                        } ${moment(new Date(item.created_at)).format("HH:mm")}`}
                      </p>
                    )}
                    {item.sender_type === "STORE" && item.failed && (
                      <div className="flex">
                        <img
                          src={`${process.env.PUBLIC_URL}/svg/ic_important.svg`}
                          alt="답변보내기"
                        />
                        <p className="failedMsg">전송실패</p>
                      </div>
                    )}
                    <h4 className={`${item.chat.length === 0 && "empty"}`}>
                      {item.chat}
                    </h4>
                    {item.sender_type !== "STORE" && (
                      <p>{`${
                        new Date(item.created_at).getHours() > 12
                          ? "오후"
                          : "오전"
                      } ${moment(new Date(item.created_at)).format(
                        "HH:mm"
                      )}`}</p>
                    )}
                  </div>
                ))}
                {status === 1 && (
                  <div className="chat finished">
                    <h4>상담이 종료되었습니다</h4>
                  </div>
                )}
                <div ref={chatEndRef} />
              </div>
            </div>
            {status !== 1 && (
              <div className="receivedWrap">
                <textarea
                  value={reply}
                  onChange={(e) => setReply(e.target.value)}
                  placeholder="답변을 입력해주세요"
                  onKeyDown={handleKeyPress}
                  disabled={status === 1}
                  onCompositionStart={handleCompositionStart}
                  onCompositionEnd={handleCompositionEnd}
                />
                <button onClick={sendRequest} className="confirmButton">
                  <h3>답변 보내기</h3>
                </button>
                <button
                  onClick={() => setVisibleConfirm(true)}
                  className="endButton"
                >
                  <h3>상담 종료하기</h3>
                </button>
              </div>
            )}
          </div>
        </div>
      </Style>
      <ConfirmModal
        isVisible={visibleConfirm}
        setVisible={setVisibleConfirm}
        title={"상담을 종료하시겠습니까\n종료 후 대화내역은 모두 삭제됩니다"}
        confirmText="종료"
        cancelText="취소"
        onConfirm={finishChat}
      />
    </Modal>
  );
};

export default ChatDetailModal;

const Style = styled.div`
  .flex {
    display: flex;
    align-items: center;
  }
  li::marker {
    color: #4dd2ae;
  }

  .modalWrapper {
    display: flex;
    height: 90dvh;
    flex-direction: column;
    gap: 16px;
    overflow: hidden;
    text-align: center;
    padding: 18px 0;
  }
  .modalTitle {
    .headerBar {
      width: 44px;
      height: 5px;
      margin: 0 auto;
      border-radius: 10px;
      background: #4dd2ae;
    }
    img {
      height: 32px;
    }
    h2 {
      margin-top: 12px;
      font-size: 24px;
      font-weight: 600;
      color: #ff4a4a;
      text-align: center;
    }
    .warningWrap {
      margin: 14px auto 0 auto;
      display: flex;
      align-items: center;
      width: fit-content;
      gap: 6px;
      border-radius: 50px;
      padding: 3px 20px;
      background: #ffeeee;
      img {
        height: 14px;
      }
      h4 {
        font-size: 14px;
        line-height: 24px;
        color: #ff6060;
        font-weight: 500;
      }
      span {
        margin-left: 10px;
        font-size: 11px;
        line-height: 24px;
        color: #ff6060;
        font-weight: 500;
      }
    }
  }

  .modalContent {
    display: flex;
    flex-direction: column;
    gap: 16px;
    height: 100%;
    padding: 0 8%;
    overflow: auto;
    .chatWrap {
      flex: 1;
      .title {
        padding: 10px 0;
        background: #4e4e4e;
        border-radius: 10px 10px 0 0;
        text-align: center;
        h3 {
          font-size: 20px;
          line-height: 28px;
          font-weight: 600;
          color: #ffffff;
        }
      }
      .content {
        height: calc(100% - 48px);
        max-height: 32dvh;
        display: flex;
        flex-direction: column;
        gap: 10px;
        background: #efefef;
        border: none;
        border-radius: 0 0 10px 10px;
        padding: 20px;
        overflow: auto;
      }

      .chat {
        display: flex;
        position: relative;
        align-items: flex-end;
        justify-content: flex-start;
        white-space: pre-line;
        width: 100%;

        h4 {
          font-size: 18px;
          line-height: 26px;
          color: #555555;
          font-weight: 400;
          padding: 6px 20px;
          background: #ffffff;
          border-radius: 20px;
          white-space: pre-line;
          word-break: break-all;
          max-width: 80%;
        }
        p {
          font-size: 12px;
          line-height: 18px;
          font-weight: 500;
          color: #737373;
          margin: 0 0 0 6px;
        }
        h4.empty {
          width: 60px;
          height: 38px;
        }
      }
      .chat.mine {
        justify-content: flex-end;

        h4 {
          color: #ffffff;
          background: #40977f;
        }
        p {
          text-align: right;
          margin: 0 6px 0 0;
        }
      }
      .failedMsg {
        white-space: nowrap;
        font-weight: 500;
        color: #ff6060;
      }
    }

    .chat.finished {
      margin-top: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      h4 {
        padding: 4px 20px;
        border-radius: 50px;
        border: 1px solid #e5e5e5;
        font-size: 12px;
        line-height: 18px;
        font-weight: 400;
        color: #979797;
        background: transparent;
      }
    }

    .receivedWrap {
      display: flex;
      flex-direction: column;
      gap: 12px;
      textarea {
        width: 100%;
        height: 100px;
        padding: 12px 24px;
        background: #ffffff;
        border: 1px solid #cecece;
        border-radius: 10px;
        font-size: 18px;
        line-height: 24px;
        color: #555555;
        font-weight: 400;
      }
      textarea::placeholder {
        color: #979797;
      }
      textarea:focus {
        outline-color: #4dd2ae;
      }
    }
  }

  .confirmButton {
    margin: 6px 0 0 0;
    padding: 12px 0;
    background: #4dd2ae;
    border: none;
    border-radius: 10px;
    h3 {
      line-height: 24px;
      font-weight: 700;
    }
  }
  .endButton {
    padding: 11px 0;
    background: #fff;

    border: 1px solid #4dd2ae;
    border-radius: 10px;
    h3 {
      line-height: 24px;
      font-weight: 700;
      color: #4dd2ae;
    }
  }
`;
